import _uniqueId from "lodash/uniqueId";
import React from 'react';
import { View, Text } from '@react-pdf/renderer';
import { getPrnRoles, getRoles, getRolesString } from '@mummssoftware/utils/utils';
import { styles } from '../../../utils/styles';
/* 
this component is needed as a static reference in the context
to prevent very long load times/processing time
when going to print Orders and Notes with the new ReactPDF work

currently PSO text is returned using strings containing <p>, <em>, etc elements 
that need to be parsed through and filtered to be compatible with ReactPDF

the parse() function from the html-react-parser package CAN accept ReactPDF as a library,
so maybe future work can focus on replacing those <p> etc in the string with appropriately 
styled <Text> ReactPDF elements
*/

export const StandingOrderUI = ({
  standingOrderSplit,
  order,
  standingOrder
}) => {
  const standingOrderUI = standingOrderSplit && standingOrderSplit.map(line => {
    if (line.includes('<strong>')) {
      const regex = /<strong>|<\/strong>|<u>|<\/u>/g;
      const lineString = line.replaceAll(regex, '');

      const uniqueId = _uniqueId('underlined-bold-line-');

      return /*#__PURE__*/React.createElement(Text, {
        key: uniqueId,
        style: [styles.fontWeightBold, styles.fontSizeTenPt, styles.textDecorationUnderline, styles.pYPointOneCm]
      }, lineString);
    }

    if (line.includes('<em>') && line.includes('<s>')) {
      const regex = /<em>|<\/em>|<u>|<\/u>|<s>|<\/s>/g;
      const lineString = line.replaceAll(regex, '');

      const uniqueId = _uniqueId('underlined-strikethrough-line-');

      return /*#__PURE__*/React.createElement(Text, {
        key: uniqueId,
        style: [styles.CPFTableDetailsText, styles.textDecorationUnderline, styles.textDecorationLineThrough, styles.pYPointOneCm]
      }, lineString);
    }

    if (line.includes('<em>')) {
      const regex = /<em>|<\/em>|<u>|<\/u>/g;
      const lineString = line.replaceAll(regex, '');

      const uniqueId = _uniqueId('underlined-line-');

      return /*#__PURE__*/React.createElement(Text, {
        key: uniqueId,
        style: [styles.CPFTableDetailsText, styles.textDecorationUnderline, styles.pYPointOneCm]
      }, lineString);
    }

    if (line.includes('<s>')) {
      const regex = /<s>|<\/s>/g;
      const lineString = line.replaceAll(regex, '');

      const uniqueId = _uniqueId('line-through-line-');

      return /*#__PURE__*/React.createElement(Text, {
        key: uniqueId,
        style: [styles.CPFTableDetailsText, styles.textDecorationLineThrough, styles.pYPointOneCm]
      }, lineString);
    }

    if (line.includes('<br>')) {
      const regex = /<br>|<\/br>/g;
      const lineString = line.replaceAll(regex, '');

      const uniqueId = _uniqueId('line-break-line');

      return /*#__PURE__*/React.createElement(Text, {
        key: uniqueId,
        style: [styles.CPFTableDetailsText, styles.pYPointOneCm]
      }, lineString);
    }

    const uniqueId = _uniqueId('line-');

    return /*#__PURE__*/React.createElement(Text, {
      key: uniqueId,
      style: [styles.CPFTableDetailsText, styles.pYPointOneCm]
    }, `${line}`);
  });
  const prnRoles = getPrnRoles(standingOrder);
  const roles = getRoles(prnRoles);
  const textRoles = roles.length ? roles.toString() : false;
  return /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(View, {
    style: [styles.width100]
  }, textRoles && /*#__PURE__*/React.createElement(Text, {
    style: [styles.CPFTableDetailsText, styles.pYPointOneCm]
  }, getRolesString(roles, textRoles))), standingOrderUI);
};
export const toPSOComponents = (orders, psosGlobal) => orders.filter(order => order.haspatientstandingorder && order.patientstandingordertext).map(psoOrder => {
  const psoHTMLString = psoOrder.patientstandingordertext;
  const standingOrderSplit = psoHTMLString.replaceAll('<p>', '').replaceAll('\t', '').split('</p>');
  const globalOrderSameId = psosGlobal === null || psosGlobal === void 0 ? void 0 : psosGlobal.find(globalPSO => globalPSO.id === psoOrder.patientstandingorderid.toString());
  const order = globalOrderSameId;
  return {
    [psoOrder.id]: /*#__PURE__*/React.createElement(StandingOrderUI, {
      key: psoOrder.id,
      standingOrderSplit: standingOrderSplit,
      standingOrder: psoOrder,
      order: order
    })
  };
});